import { render, staticRenderFns } from "./DoctorComplain.vue?vue&type=template&id=daefbfac&scoped=true"
import script from "./DoctorComplain.vue?vue&type=script&lang=js"
export * from "./DoctorComplain.vue?vue&type=script&lang=js"
import style0 from "./DoctorComplain.vue?vue&type=style&index=0&id=daefbfac&prod&lang=scss&scoped=true"
import style1 from "./DoctorComplain.vue?vue&type=style&index=1&id=daefbfac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daefbfac",
  null
  
)

export default component.exports